/*
  SOFI: brand search box for long Brand filter lists (snippets/facets.liquid,
  [data-sofi-brand-search]). Filters the brand checkbox list in place. Its events are
  stopped in the capture phase so facets.js never sees them (typing must not reload
  the grid). Guards against loading twice. No network calls.
  (The phone department slide-out that used to live here was removed in the
  2026-11-02 collection page redesign; phones use the chip row under the title.)
*/
(function () {
  if (window.__sofiSidebar) return;
  window.__sofiSidebar = true;

  function isBrandSearch(el) {
    return el && el.matches && el.matches('[data-sofi-brand-search]');
  }

  function filterBrands(input) {
    var scope = input.closest('.facets__display-vertical, .mobile-facets__submenu');
    if (!scope) return;
    var list = scope.querySelector('ul');
    if (!list) return;
    var q = input.value.trim().toLowerCase();
    scope.classList.toggle('sofi-bs-searching', q !== '');
    list.querySelectorAll('li').forEach(function (li) {
      var labelEl = li.querySelector('.facet-checkbox__text-label') || li;
      var match = q === '' || labelEl.textContent.toLowerCase().indexOf(q) !== -1;
      li.classList.toggle('sofi-bs-miss', !match);
    });
    watchScope(scope, input);
  }

  // facets.js swaps the brand list (outerHTML) after a box is ticked, which drops
  // our classes while the typed query stays. Re-apply the query when that happens.
  function watchScope(scope, input) {
    if (scope.__sofiBsObserver || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (!input.isConnected) {
        observer.disconnect();
        scope.__sofiBsObserver = null;
        return;
      }
      filterBrands(input);
    });
    observer.observe(scope, { childList: true, subtree: true });
    scope.__sofiBsObserver = observer;
  }

  ['input', 'change', 'search'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (!isBrandSearch(event.target)) return;
        event.stopPropagation();
        filterBrands(event.target);
      },
      true
    );
  });

  // Enter inside the box would submit the filter form as a full page load.
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Enter' && isBrandSearch(event.target)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
